import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReplaySubject } from 'rxjs';



@Injectable({ providedIn: 'root' })
export class ContactUsDialogService {


    private readonly _events$ = new ReplaySubject<'opening' | 'opened' | 'closing' | 'closed'>(1)
    readonly events = this._events$.asObservable()

    openContactUsDialog() {
        this._events$.next('opening')
        const dialogEl = document.querySelector('#contactUsDialog') as HTMLDialogElement;
        if (dialogEl.hasAttribute('open')) return;
        document.body.style.overflow = 'hidden';
        dialogEl.showModal();

        dialogEl.addEventListener("click", (e) => {
            if (dialogEl === e.target) this.closeContactUsDialog(e);
        })
        this._events$.next('opened')
    }

    closeContactUsDialog(e?: any) {
        this._events$.next('closing')
        e?.preventDefault();
        const dialogEl = document.querySelector('#contactUsDialog') as HTMLDialogElement;
        if (!dialogEl.hasAttribute('open')) return;

        dialogEl.setAttribute("closing", "");

        dialogEl.addEventListener('animationend', () => {
            dialogEl.removeAttribute("closing");
            dialogEl.close();
            document.body.style.overflow = 'auto';
            this._events$.next('closed')
        }, { once: true });

    }
}